import { useSmartEvent } from '../../../core/hooks';
import { useGetter, useEffect, plugin } from '../slots';
import { BOTTOM_CURSOR, incTopped, decBotted } from '../Cursor';

// key codes
const ESC = 27;
const ENTER = 13;
const UP = 38;
const DOWN = 40;


const Plugin = plugin('keyboard', null)(() => {

    const [dropdownOpened] =  useEffect('dropdownOpened');
    const [dropdownClosed] =  useEffect('dropdownClosed');

    const select =            useGetter('select');
    const dropdown =          useGetter('dropdown');
    const dropdownTarget =    useGetter('dropdownTarget');
    const cursorController =  useGetter('cursor');
    const action =            useGetter('action');

    const bottom = BOTTOM_CURSOR;
    const top = dropdownTarget.getMutableData().length - 1;

    const up = () => cursorController.modify(decBotted(bottom));
    const down = () => cursorController.modify(incTopped(top));

    const handler = (e: KeyboardEvent) => {
        const key = e.keyCode;

        switch(key){
            case ENTER: {
                if(action.isVisible()){
                    action.batch();
                }
                else {
                    select.batch();
                }
                return;
            }
            case UP: {
                up();
                e.preventDefault();
                return;
            }
            case DOWN: {
                down();
                e.preventDefault();
                return;
            }
            case ESC: {
                select.off();
                e.preventDefault();
                return;
            }
        }
    };

    useSmartEvent<KeyboardEvent>({
        handler,
        on: (h) => window.addEventListener('keydown', h),
        off: (h) => window.removeEventListener('keydown', h),
        predicate: dropdown.isOpen,
        signal: [dropdownOpened, dropdownClosed],
    });

    return null;
});

export default Plugin;
